<bit-layout>
  <ng-content select="app-side-nav, [slot=side-nav]" slot="side-nav"></ng-content>
  <ng-content></ng-content>
</bit-layout>
